// Keep in sync with RPGLogsBackEnd: src/com/rpglogs/reports/Styles.java
export default function getColorForAbilityType(type: number | string) {
  const numericType = Number(type);
  if (numericType === 1) return 'rgb(229, 204, 128)';
  if (numericType === 2) return 'rgb(100%, 100%, 56%)';
  if (numericType === 4) return 'rgb(92%, 27%, 38%)';
  if (numericType === 8) return 'rgb(82%, 98%, 60%)';
  if (numericType === 16) return 'rgb(29%, 50%, 100%)';
  if (numericType === 32) return 'rgb(72%, 66%, 94%)';
  if (numericType === 64 || numericType === 80) return 'rgb(56%, 95%, 100%)';
  if (numericType >= 124 && numericType <= 127) return 'rgb(163, 48, 201)';
  if (numericType === 128) return 'rgb(80%, 44%, 9%)';
  if (numericType === 256) return '#2599be';
  if (numericType === 512) return 'rgb(75%, 75%, 75%)';
  return 'white';
}
